const jsonUtils = {
  getValor: (chave, jsonResultado, is_object = false) => {
    try {
      let res = jsonResultado;
      let chaves = chave.split(".");
      for (let c of chaves) {
        res = res[c];
        if (res == null || res == undefined) {
          return undefined;
        }
      }
      // if (typeof res === "object" && !is_object) {
      //   return undefined;
      // }
      return res;
    } catch (e) {}
    return undefined;
  },
};

export default jsonUtils;
